import { Component, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { environment } from 'src/environments/environment';
import { LanguageService } from 'src/app/services';
import { LANGUAGES } from 'src/app/utils/constant';
const packageJson = require('../../../../package.json');
import * as _ from 'lodash';

@Component({
  selector: 'esc-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public webtoolVersion = packageJson.version;
  languages = LANGUAGES;
  qaVersioning = '.74';

  constructor(
    public media: MediaObserver,
    public languageService: LanguageService,
    ) { }

  ngOnInit() {
    if(environment.api.endpoints[0].endpoint != 'https://swiftrewards-api.escienceapps.com') {
      this.webtoolVersion = this.webtoolVersion + this.qaVersioning;
    }
  }

  selectedLanguage() {
    let self = this;
    let idx = _.findIndex(this.languages, function(o) { 
      return o.value == self.languageService.getLocale() 
    });
    return _.get(this.languages[idx], 'name');
  }

  changeLanguage(language){
    this.languageService.updateLocale(_.get(language, 'value'));
  }
}
